import usePlatform from "contexts/platform/use-platform"
import React, { useState } from "react"
import { useQuery } from "react-query"
import { IPolicyholder } from "platform-client/types"
import { isObjectNull } from "utils/pocketknife/object-is-null"
import { StringIsEmptyNullable } from "utils/pocketknife/string-is-empty"
import ListCard from "components/ListCard"
import { Address } from "components/Address"
import { LayoutCardEmpty } from "components/LayoutCardEmpty"
import { CardHeader } from "./ClientCardHeader"
import { Button } from "antd"

export const Client: React.FunctionComponent<IClientInfo> = (props) => {
  const [clientUsage, setClientUsage] = useState<
    IPolicyholder | undefined | null
  >(props.client)
  const platform = usePlatform()

  const { isLoading } = useQuery(
    ["client", props.referenceId],
    async () => platform.policyholders.getPolicyholder(props.referenceId),
    {
      enabled: !!props.referenceId && !props.client,
      onSuccess: (result) => {
        setClientUsage(result)
      }
    }
  )

  if (
    isLoading === false &&
    StringIsEmptyNullable(clientUsage?.legalName) &&
    isObjectNull(clientUsage?.contact?.name) &&
    isObjectNull(clientUsage?.contactAddress) &&
    StringIsEmptyNullable(clientUsage?.contact?.emailAddress) &&
    !clientUsage?.contact?.phoneNumber
  ) {
    return (
      <LayoutCardEmpty
        title="Client"
        className={props.className}
        emptyText="No Client details"
      />
    )
  }

  return (
    <>
      <ListCard
        loading={isLoading}
        title={
          <CardHeader title="Client">
            {typeof props.onEditClick === "function" && (
              <Button
                onClick={() => {
                  if (props.onEditClick) props.onEditClick()
                }}
              >
                Edit
              </Button>
            )}
          </CardHeader>
        }
        className={props.className}
      >
        {clientUsage !== undefined && clientUsage !== null && (
          <>
            {clientUsage?.legalName &&
              !StringIsEmptyNullable(clientUsage?.legalName) && (
                <ListCard.Item label="Legal Name">
                  {clientUsage?.legalName}
                </ListCard.Item>
              )}
            {clientUsage?.contact &&
              !isObjectNull(clientUsage?.contact?.name) && (
                <ListCard.Item label="Contact Name">
                  {`${
                    clientUsage.contact.name.title
                      ? clientUsage.contact.name.title
                      : ""
                  } ${
                    clientUsage?.contact.name.firstName
                      ? clientUsage?.contact.name.firstName
                      : ""
                  } ${
                    clientUsage.contact.name.lastName
                      ? clientUsage.contact.name.lastName
                      : ""
                  }`}
                </ListCard.Item>
              )}
            {clientUsage?.contact?.emailAddress &&
              !StringIsEmptyNullable(clientUsage.contact?.emailAddress) && (
                <ListCard.Item label="Contact Email address">
                  {clientUsage?.contact?.emailAddress}
                </ListCard.Item>
              )}

            {clientUsage?.businessName && (
              <ListCard.Item label="Business Name">
                {`${clientUsage?.businessName}`}
              </ListCard.Item>
            )}
            {clientUsage?.contact?.phoneNumber && (
              <ListCard.Item label="Contact Telephone">
                {clientUsage?.contact?.phoneNumber}
              </ListCard.Item>
            )}
            {!isObjectNull(clientUsage?.contactAddress) && (
              <ListCard.Item label="Contact Address">
                <Address address={clientUsage?.contactAddress} />
              </ListCard.Item>
            )}
          </>
        )}
      </ListCard>
    </>
  )
}

export interface IClientInfo {
  referenceId?: string
  client?: IPolicyholder
  className?: string
  onEditClick?: (id?: string) => void
}
